import React from 'react';
import {
    string,
    arrayOf,
    shape,
    oneOfType,
    number,
    object,
    bool,
} from 'prop-types';
import { connectCurrentRefinements } from 'connectors';
import { quickFiltersShape } from 'shapes';
import classnames from 'classnames';
import { shouldShowQuickFilters } from 'utils/quickFilters';
import { QuickFilters, QuickLink } from './components';

function QuickFiltersWrapper(props) {
    const {
        quickFilters,
        items,
        className,
        isInCategorySearch,
        ...otherProps
    } = props;

    const quickFiltersWrapperClassName = classnames(
        className,
        'quickfilters__wrapper',
    );

    if (quickFilters.quickLink) {
        return (
            <QuickLink
                className={quickFiltersWrapperClassName}
                {...quickFilters}
                {...otherProps}
            />
        );
    }

    if (!shouldShowQuickFilters(quickFilters, items)) {
        return null;
    }

    return (
        <QuickFilters
            {...quickFilters}
            className={className}
            replaceSearchState
            isInCategorySearch={isInCategorySearch}
            {...otherProps}
        />
    );
}

QuickFiltersWrapper.propTypes = {
    className: string,
    quickFilters: quickFiltersShape,
    items: arrayOf(
        shape({
            attribute: string.isRequired,
            currentRefinement: oneOfType([
                string,
                number,
                object,
                arrayOf(string),
                bool,
            ]),
        }),
    ),
    isInCategorySearch: bool,
};

QuickFiltersWrapper.defaultProps = {
    className: null,
    items: [],
    quickFilters: {},
    isInCategorySearch: false,
};

export default connectCurrentRefinements(QuickFiltersWrapper);
